// extracted by mini-css-extract-plugin
module.exports = {"bodyTitleBlock":"TransitionProposalFlow-module__bodyTitleBlock--2GWY7","innerContent":"TransitionProposalFlow-module__innerContent--1A8n2"};